import React, { useState, useEffect } from 'react'
import { SaveUpdatePenaltyconfig } from '../../../AdminActionCreator.component'
import PopUp from "../../../../../presentationals/Popup/Popup.component";
import Loader from '../../../../../presentationals/Loader/Loader.component';
import { APIS } from '../../../../../../utils/api-factory'
import moment from 'moment';
export default function AddEditLendor({ editData, handleSavebtn, admin }) {
    const PageType = (Object.keys(editData)?.length > 0 ? 'Edit' : '')
    const [loader, setloader] = useState(false)
    const [popupstate, setPopupState] = useState(false)
    const [popupStatus, setpopupStatus] = useState('')

    const [roiNewValue, setRoiNewValue] = useState('')

    const [data, setData] = useState({
        minLoan: "",
        maxLoan: "",
        slabNumber: "",
        penaltyValue: "",
        penaltyInterestRate: "",
        bounceCharge: "",
    })

    useEffect(() => {

        if (editData?.id) {
            setData({
                minLoan: editData?.minLoan || "",
                maxLoan: editData?.maxLoan || "",
                slabNumber: editData?.slabNumber || "",
                penaltyValue: editData?.penaltyValue || "",
                penaltyInterestRate: editData?.penaltyInterestRate || "",
                bounceCharge: editData?.bounceCharge || "",
            })
        }
    }, [editData])




    const handlechange = (e) => {
        const { name, value } = e.target;


        setData((prevData) => ({
            ...prevData,
            [name]: value
        }))
    }

    const handlesave = (type) => {
        if (type == 'back') {
            handleSavebtn()
        }
        else {
            let obj = {
                ...data
            }
            if (type == "save") {
                obj.createdAt = new Date().toISOString().replace('Z', '+0000');
                obj.updatedAt = "";
                obj.createdBy = admin?.emailId;
                obj.updateBy = "";
            } else if (type == "update") {
                obj.id = editData?.id
                obj.createdAt = editData?.createdAt;
                obj.updatedAt = new Date().toISOString().replace('Z', '+0000');
                obj.createdBy = editData?.createdBy;
                obj.updateBy = admin?.emailId;
            }
            setloader(true)


            SaveUpdatePenaltyconfig(obj, (Callback) => {
                setloader(false)
                if (Callback == 'success') {
                    setPopupState(true)
                    setpopupStatus('Success')
                    setTimeout(() => {
                        handleSavebtn()
                    }, 4000)

                    setData({
                        minLoan: "",
                        maxLoan: "",
                        slabNumber: "",
                        penaltyValue: "",
                        penaltyInterestRate: "",
                        bounceCharge: "",
                    })
                } else {
                    setPopupState(true)
                    setpopupStatus('Error')
                }
                removePopup()
            })
        }

    }


    const closePopup = () => {
        setPopupState(false)
    }

    const removePopup = () => {
        setTimeout(() => {
            closePopup()
        }, 2000)
    }



    return (
        <>
            <div className="AddEditExecutor">
                <button style={{ marginTop: '20px' }} className='btn btn-primary' onClick={() => handlesave('back')}>Back</button>

                {
                    loader ?
                        <Loader />
                        : ''}
                {
                    popupstate ?
                        <PopUp closePopup={closePopup} popupStatus={popupStatus} />
                        : ''}

                <h3 className='heading'>{PageType}</h3>

                <div className="forms">
                    <div className="row">

                        <div className="col-sm-6 col-xs-12">
                            <div className="formgrp newmargin">
                                <label htmlFor="minLoan">Min Loan</label>
                                <input className='inputtag' type="number" id="minLoan" placeholder='Min Loan Amount' name="minLoan" value={data?.minLoan} onChange={(e) => handlechange(e)} />
                            </div>
                        </div>
                        <div className="col-sm-6 col-xs-12">
                            <div className="formgrp newmargin">
                                <label htmlFor="maxLoan">Max Loan</label>
                                <input className='inputtag' type="number" id="maxLoan" placeholder='Max Loan Amount' name="maxLoan" value={data?.maxLoan} onChange={(e) => handlechange(e)} />
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className="col-sm-6 col-xs-12">
                            <div className="formgrp newmargin">
                                <label htmlFor="slabNumber">Slab Number</label>
                                <input className='inputtag' type="number" id="slabNumber" placeholder='Slab Number' name="slabNumber" value={data?.slabNumber} onChange={(e) => handlechange(e)} />
                            </div>
                        </div>
                        <div className="col-sm-6 col-xs-12">
                            <div className="formgrp newmargin">
                                <label htmlFor="penaltyValue">Penalty Value</label>
                                <input className='inputtag' type="number" id="penaltyValue" placeholder='Penalty Value' name="penaltyValue" value={data?.penaltyValue} onChange={(e) => handlechange(e)} />
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className="col-sm-6 col-xs-12">
                            <div className="formgrp newmargin">
                                <label htmlFor="penaltyInterestRate">Penalty Interest Rate</label>
                                <input className='inputtag' type="number" id="penaltyInterestRate" placeholder='Penalty Interest Rate' name="penaltyInterestRate" value={data?.penaltyInterestRate} onChange={(e) => handlechange(e)} />
                            </div>
                        </div>
                        <div className="col-sm-6 col-xs-12">
                            <div className="formgrp newmargin">
                                <label htmlFor="bounceCharge">Bounce Charge</label>
                                <input className='inputtag' type="number" id="bounceCharge" placeholder='Bounce Charge' name="bounceCharge" value={data?.bounceCharge} onChange={(e) => handlechange(e)} />
                            </div>
                        </div>
                    </div>



                    <div className='savebtn'>

                        <button className='btn' onClick={() => handlesave(PageType == 'Edit' ? 'update' : 'save')}>{PageType == 'Edit' ? 'Update' : 'Save'}</button>
                    </div>
                </div>
            </div>

        </>
    )
}
